( function( $, window ) {
	'use strict';

	$( function() {
		const { inView } = Motion;

		inView( '.js-waypoint', ( element ) => {
			element.classList.add( 'is-visible' );
		} );
	} );
} )( jQuery, window );
